export const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: "aunjai-api-auth-token",
  ID_CARD: "idCard",
  DATE_OF_BIRTH: "dob",
  SEEN_NOTIFICATION_IDS: "seen-notification-ids",
};
